import { Method } from './DataUtils.js';
import * as DataUtils from './DataUtils.js';
import * as DTOs from '../DTOs/PartidoDTOs.js';

export const FetchPartido = (idPartido) => {
  return DataUtils.FetchLista('partidos/' + idPartido);
};

export const FetchFormacion = (idPartido, idEquipo) => {
  return DataUtils.FetchLista('partidos/' + idPartido + '/formaciones/equipos/' + idEquipo);
};

export const FetchGoles = (idPartido) => {
  return DataUtils.FetchLista('partidos/' + idPartido + '/goles');
};

export const FetchResultados = (idPartido) => {
  return DataUtils.FetchLista('partidos/' + idPartido + '/resultados');
};

export const PostResultado = async (idPartido, resultado) => {
  return DataUtils.SaveObject(
    Method.POST,
    'partidos/' + idPartido + '/resultados',
    DTOs.resultadoPartido(resultado, idPartido)
  );
};

export const PutResultado = async (idPartido, resultado) => {
  return DataUtils.SaveObject(
    Method.PUT,
    'partidos/' + idPartido + '/resultados/' + resultado.id,
    DTOs.resultadoPartido(resultado, idPartido)
  );
};

export const DeleteResultado = async (idPartido, idResultado) => {
  return DataUtils.SaveObject(
    Method.DELETE,
    'partidos/' + idPartido + '/resultados/' + idResultado,
    null
  );
};

export const FetchSustituciones = (idPartido) => {
  return DataUtils.FetchLista('partidos/' + idPartido + '/sustituciones');
};

export const PatchPartido = async (idPartido, dto) => {
  return await DataUtils.SaveObject(Method.PATCH, 'partidos/' + idPartido, dto);
};

export const PatchParticipanteAmonestado = async (idPartido, idEquipo, participante) => {
  return await DataUtils.SaveObject(
    Method.PATCH,
    'partidos/' + idPartido + '/formaciones/' + participante.idPartidoFormacion,
    DTOs.patchFormacionAmonestado(participante)
  );
};

export const DeleteExpulsion = async (idPartido, idExpulsion) => {
  return await DataUtils.SaveObject(
    Method.DELETE,
    'partidos/' + idPartido + '/expulsiones/' + idExpulsion,
    null
  );
};

export const PostExpulsion = async (idPartido, datosExpulsion) => {
  return await DataUtils.SaveObject(
    Method.POST,
    'partidos/' + idPartido + '/expulsiones',
    DTOs.expulsionPartido(datosExpulsion)
  );
};

export const PutExpulsion = async (idPartido, datosExpulsion) => {
  return await DataUtils.SaveObject(
    Method.PUT,
    'partidos/' + idPartido + '/expulsiones/' + datosExpulsion.id,
    DTOs.expulsionPartido(datosExpulsion)
  );
};

export const PostFormacion = async (idPartido, idEquipo, formacion) => {
  return await DataUtils.SaveObject(
    Method.POST,
    'partidos/' + idPartido + '/formaciones/equipos/' + idEquipo,
    DTOs.formacionPartido(formacion)
  );
};

export const PutFormacion = async (idPartido, idEquipo, formacion) => {
  return await DataUtils.SaveObject(
    Method.PUT,
    'partidos/' + idPartido + '/formaciones/equipos/' + idEquipo,
    DTOs.formacionPartido(formacion)
  );
};

export const DeleteFormacion = async (idPartido, idFormacion) => {
  return await DataUtils.SaveObject(
    Method.DELETE,
    'partidos/' + idPartido + '/formaciones/' + idFormacion,
    null
  );
};

export const DeleteGol = async (idPartido, idGol) => {
  return await DataUtils.SaveObject(
    Method.DELETE,
    'partidos/' + idPartido + '/goles/' + idGol,
    null
  );
};

export const PostGol = async (idPartido, datosGol) => {
  return await DataUtils.SaveObject(
    Method.POST,
    'partidos/' + idPartido + '/goles',
    DTOs.insertGolPartido(datosGol)
  );
};

export const PutGol = async (idPartido, datosGol) => {
  return await DataUtils.SaveObject(
    Method.PUT,
    'partidos/' + idPartido + '/goles/' + datosGol.id,
    DTOs.updateGolPartido(datosGol)
  );
};

export const DeleteSustitucion = async (idPartido, idSustitucion) => {
  return await DataUtils.SaveObject(
    Method.DELETE,
    'partidos/' + idPartido + '/sustituciones/' + idSustitucion,
    null
  );
};

export const PostSustitucion = async (idPartido, datosSustitucion) => {
  return await DataUtils.SaveObject(
    Method.POST,
    'partidos/' + idPartido + '/sustituciones',
    DTOs.sustitucionPartido(datosSustitucion)
  );
};

export const PutSustitucion = async (idPartido, datosSustitucion) => {
  return await DataUtils.SaveObject(
    Method.PUT,
    'partidos/' + idPartido + '/sustituciones/' + datosSustitucion.id,
    DTOs.sustitucionPartido(datosSustitucion)
  );
};
